/**
 * Created by Carsten Bühler
 * User: c.buehler on 04.05.2018
 * Copyright: xdot GmbH 2018
 */

import React from 'external/react';
import ReactDOM from 'external/react-dom';
import { Button, FormControl, FormGroup, FormLabel, HelpBlock, InputGroup } from 'external/react-bootstrap';

const wrapWithInlineFormComponent = (FormComponent, ViewComponent) => {

  class WrapWithInlineFormComponent extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        isEdit: props.initialIsEdit || false,
        isEditable: props.startEdit !== undefined,
      };
      this.editElement = undefined;
      this.startEdit = this.startEdit.bind(this);
      this.stopEdit = this.stopEdit.bind(this);
      this.submit = this.submit.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.isSaving && this.props.formValid && !nextProps.isSaving && this.state.isEdit && !this.props.disableCloseOnSuccessfullSubmit === true) {
        //submit successful
        this.setState({ isEdit: false });
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.state.isEdit && !prevState.isEdit && this.focusInput) {
        // eslint-disable-next-line react/no-find-dom-node
        ReactDOM.findDOMNode(this.focusInput).focus(); //C.Bühler: findDOMNode is not deprecated. ReactBootstrap-FormComponents does not support focus as function.
      }
    }

    stopEdit() {
      this.setState({ isEdit: false }, () => this.props.cancel && this.props.cancel());
    }

    startEdit() {
      if (this.props.formValid) {
        this.setState({ isEdit: true });
        this.props.startEdit && this.props.startEdit();
      }
    }

    submit() {
      if (this.props.formValid) {
        this.setState({ isEdit: false }, () => this.props.submit && this.props.submit());
      }
    }

    componentWillUnmount() {
      this.props.cancel && this.props.cancel();
    }

    render() {
      return this.state.isEdit ?
        <FormComponent
          {...this.props}
          stopEdit={this.stopEdit}
          focusRef={el => this.focusInput = el}
          submit={this.submit}
        /> :
        <ViewComponent
          {...this.props}
          startEdit={this.startEdit}
          isEditable={this.state.isEditable}
        />;
    }
  }

  WrapWithInlineFormComponent.displayName = `WrapWithInlineFormComponent(${getDisplayName(FormComponent)})`;

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return WrapWithInlineFormComponent;
};

/*
InlineFormControl.propTypes = {
    children: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,

    startEdit: PropTypes.func,
    cancel: PropTypes.func,
    value: PropTypes.node,
    initialIsEdit: PropTypes.bool,
    hideSaveButton: PropTypes.bool,
    hideCancelButton: PropTypes.bool,
    isEditing: PropTypes.bool
};
*/

let InlineFormControlGroup = props => {
  const {
    controlLabel,
    propName,
    item,
    isSaving,
    isEdited,
    onChange,
    stopEdit,
    startEdit,
    focusRef,
    cancel,
    submit,
    reset,
    formError,
    formValidation,
    formValid,
    children,
    hideSaveButton = false,
    hideCancelButton = false,
    ...otherProps
  } = props;
  const value = props.value || item[propName];

  const propError = formValidation[propName];

  const validateProps = formValidation ? { validationState: propError ? 'error' : null } : {};

  const onKeyDown = (e) => {
    if (e.keyCode === 27) {
      stopEdit();
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <FormGroup {...validateProps}>
      <InputGroup>
        {
          controlLabel &&
          <FormLabel>{controlLabel}</FormLabel>
        }
        <FormControl
          {...otherProps}
          ref={focusRef}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          submit={submit}
          cancel={cancel}
          reset={reset}
        />
        <InputGroup.Append>
          {
            hideSaveButton !== true &&
            <InlineControlBtn valid={formValid} onClick={submit}>Speichern</InlineControlBtn>
          }
          {
            hideCancelButton !== true &&
            <InlineControlBtn onClick={stopEdit}>Abbrechen</InlineControlBtn>
          }
        </InputGroup.Append>
      </InputGroup>
      {
        formValidation && propError ?
          <HelpBlock>{propError}</HelpBlock> : null
      }
    </FormGroup>);
};

// eslint-disable-next-line react/prop-types
const InlineView = ({ value, item, propName, children, startEdit, showEditIcon = true }) => (
  <div
    className="d-flex align-items-center"
    onClick={startEdit}
    title="Klicken zum Editieren"
  >
    <div className="w-100">
      {
        children ? children(startEdit) : <span>{value || item[propName]}</span>
      }
    </div>

    {
      showEditIcon &&
      <div className="px-3 py-2 d-flex align-items-center">
        <span className="icon icon-fliwas-pencil h3 m-0"/>
      </div>
    }
  </div>
);

// eslint-disable-next-line react/prop-types
const InlineControlBtn = ({ valid = true, children, onClick }) => {
  const options = !valid ? { disabled: 'disabled' } : {};

  return (
    <Button {...options} variant="primary" onClick={onClick}>{children}</Button>
  );
};
InlineControlBtn.displayName = 'InlineControlBtn';

InlineFormControlGroup = wrapWithInlineFormComponent(InlineFormControlGroup, InlineView);

export { InlineFormControlGroup, wrapWithInlineFormComponent, InlineView };




// WEBPACK FOOTER //
// ./js/components/InlineFormControl.jsx